function formatDigit(value) {
    // Check if the value has a toFixed function (i.e., it's a number-like object)
    if (typeof value.toFixed === 'function') {
      // Use toFixed to limit to 12 decimal places
      let fixedValue = value.toFixed(8).replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');;
      
      // Remove trailing zeroes after the decimal point
      return fixedValue
    }
  
    // If no toFixed method, try converting the value to a number
    const numValue = Number(value);
  
    // Check if the conversion was successful (i.e., the result is a valid number)
    if (!isNaN(numValue)) {
      // Format the number, remove trailing zeroes, and return the result
      return numValue.toFixed(8).replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '')
    }
  
    // Return the original value if it's neither a fixed number nor convertible to a number
    return value;
  }


  export {formatDigit}